import { Component } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { FormGroup } from "@angular/forms";
import { BannerManagementComponent } from "../banner-management/banner-management";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AdvertisingPhotoComponent } from "../advertising-photo/advertising-photo";
import { AdvertisingService } from "../../../shared/services/advertising.service";
import {
    ManageAdsBannerPhotoComponent
} from "../../explore/components/ads-banner-photo/manage-ads-banner-photo.component";
import { HttpClient } from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import { AdsSubTypeConstant, DisplayViewConstant } from "../../../shared/constants/ads-type-constant";

@Component({
    selector: 'app-advertising-management',
    templateUrl: './advertising-management.html',
    styleUrls: ['advertising-management.css'],
})
export class AdvertisingManagement {
    localUserId;
    onlyKampsport;
    currentUsers = [];
    form = new FormGroup({});
    currentPartner = (this.onlyKampsport) ? BannerManagementComponent.partners.KAMPSPORT : BannerManagementComponent.partners.EXPLORER;
    partnerName = (this.onlyKampsport) ? "Kampsport" : "Explorer";
    advertisingArr = [];
    pinnedPostArr = [];
    advertisingAppArr= [];
    pinnedPostApptArr = [];
    bannerApptArr = [];
    testingMode = false;


    constructor(public advertisingService: AdvertisingService,
                protected http: HttpClient,
                public toastr : ToastrService,
                private route: ActivatedRoute,
                protected _modalService: NgbModal) {
    }

    ngOnInit() {
       this.loadAdvertisingPhoto();
        this.testingMode = this.route.snapshot.queryParams.testingMode;
    }

    loadAdvertisingPhoto() {
        this.advertisingArr = [];
        this.bannerApptArr = [];
        this.pinnedPostArr = [];
        this.advertisingAppArr= [];
        this.pinnedPostApptArr = [];
        this.advertisingService.getAdvertising(this.currentPartner, false, 'all').toPromise().then((res : any) => {
            res.Data.forEach(item => {
                this.addAdsView(item)
            })

        })
    }

    private addAdsView(item) {
        if (item.displayView === DisplayViewConstant.APP) {
            if (item.subType === AdsSubTypeConstant.PINNED) {
                this.pinnedPostApptArr.push(item);
            } else if (item.subType == AdsSubTypeConstant.APP_BANNER) {
                this.bannerApptArr.push(item);
            } else {
                this.advertisingAppArr.push(item);
            }
        } else {
            if (item.subType === AdsSubTypeConstant.PINNED) {
                this.pinnedPostArr.push(item);
            } else {
                this.advertisingArr.push(item);
            }
        }
    }

    addAdvertising() {
        const modalRef = this._modalService.open(AdvertisingPhotoComponent, {centered: true});
        modalRef.componentInstance.currentPartner = this.currentPartner;
        modalRef.componentInstance.testingMode = this.testingMode;
        modalRef.componentInstance.uploadSuccess.subscribe((res) => {
            this.loadAdvertisingPhoto();
        })
    }

    preventDefault(event, prevent) {
        if (prevent) {
            event.preventDefault();
        } else {
            return;
        }
    }

    getAdsTags(tags) {
        if (!tags) {
            return 'N/A';
        } else {
            if (tags.length) {
                return  (tags.join(', ')).toUpperCase();
            }
            return 'N/A';
        }
    }

    removeAds(ads) {
        if (confirm('Are you sure?')) {
            this.http.delete(ManageAdsBannerPhotoComponent.ADVERTISING_URL + '/' +
              ads.id)
              .subscribe(
                (res: any) => {
                    this.loadAdvertisingPhoto();
                }
              );
        }
    }

    editAds(ads) {
        const modalRef = this._modalService.open(AdvertisingPhotoComponent, {centered: true});
        modalRef.componentInstance.currentPartner = this.currentPartner;
        modalRef.componentInstance.navigateUrl = ads.navigateUrl;
        modalRef.componentInstance.filterMembersTags = ads.tags;
        modalRef.componentInstance.advertisingUrl = ads.bannerUrl;
        modalRef.componentInstance.subType = ads.subType;
        modalRef.componentInstance.language = ads.language;
        modalRef.componentInstance.status = ads.status;
        modalRef.componentInstance.groupId = ads.groupId;
        if (ads.groupId) {
            modalRef.componentInstance.groupModel = {
                groupSearchValue : ads.group.name + ' - ' + ads.group.ownerData.fullName
            };
        }

        modalRef.componentInstance.type = ads.type;
        modalRef.componentInstance.displayView = ads.displayView;
        modalRef.componentInstance.id = ads.id;
        modalRef.componentInstance.uploadSuccess.subscribe((res) => {
            this.loadAdvertisingPhoto();
        })
    }

    // Choose Partner
    choosePartner(partner) {
        switch (partner) {
            case 'explorer' :
                this.currentPartner = BannerManagementComponent.partners.EXPLORER;
                this.partnerName = 'Explorer';
                break;
            case 'canon' :
                this.currentPartner = BannerManagementComponent.partners.CANNON;
                this.partnerName = 'Canon';
                break;
            case 'hurtigruten' :
                this.currentPartner = BannerManagementComponent.partners.HURTIGRUTEN;
                this.partnerName = 'Hurtigruten';
                break;
            case 'kampsport' :
                this.currentPartner = BannerManagementComponent.partners.KAMPSPORT;
                this.partnerName = 'Kampsport';
                break;
            case 'naf' :
                this.currentPartner = BannerManagementComponent.partners.NAF;
                this.partnerName = 'NAF';
                break;
            default :
                this.currentPartner = BannerManagementComponent.partners.EXPLORER;
        }

        this.loadAdvertisingPhoto();
    }
}
